import { render, staticRenderFns } from "./YearlyIncomeReportsBox.vue?vue&type=template&id=2a6a8fdd&scoped=true"
import script from "./YearlyIncomeReportsBox.vue?vue&type=script&lang=js"
export * from "./YearlyIncomeReportsBox.vue?vue&type=script&lang=js"
import style0 from "./YearlyIncomeReportsBox.vue?vue&type=style&index=0&id=2a6a8fdd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a8fdd",
  null
  
)

export default component.exports